import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import cn from 'classnames';

import { useSettings } from '../util/queries/settings';
import { buildThemeStylesFromColors } from '../util/theme';

import IssueIndex from '../components/IssueIndex';
import Header from '../components/Header';
import Footer from '../components/Footer';

import * as styles from './Web.module.css';
import '../styles/reset.css';
import '../styles/variables.css';
import '../styles/fonts.css';
import '../styles/base.css';

const WebLayout = ({ children, theme, colors, title, initialShowAbout }) => {
  const { about } = useSettings();

  return (
    <div className={cn('root', theme)}>
      <Helmet
        htmlAttributes={{
          lang: 'es-cl'
        }}
        defaultTitle="Refracciones"
        titleTemplate={`%s – Refracciones`}
        style={[
          {
            cssText: `body { ${buildThemeStylesFromColors(colors)} }`
          }
        ]}
      >
        <title>{title}</title>
        <link rel="icon" href="/favicon.svg" type="image/svg+xml" />
        {[16, 32, 48, 128].map((size, index) => (
          <link
            key={index}
            rel="icon"
            href={`/favicon-${size}.png`}
            sizes={`${size}x${size}`}
            type="image/png"
          />
        ))}
        <link rel="apple-touch-icon" href="/apple-touch-icon.png"></link>
      </Helmet>
      <Header initialShowAbout={initialShowAbout} aboutText={about.text} />
      <main className={cn(styles.main)}>{children}</main>
      <IssueIndex />
      <Footer />
    </div>
  );
};

WebLayout.propTypes = {
  children: PropTypes.node.isRequired
};

export default WebLayout;
